import moment from "moment";
import { aggregateObject, convertToPercent, deepCopy, round, sortStringArray, truncate, getObjectFilter, daysCountFromRange, getAppData, getCorrectValue, getMarketSegment, getForecastFeedVCapacity, getForecastFeedCapacity } from "../../../app/util";
import { useDataSummary } from "../../Tile/kpiService";
import dataService from "../../../services/data.service";
import { useSelector } from "react-redux";


export function getForecastSegmentedData() {
    let otb = deepCopy(dataService.getSeriesById("OSRSegment").data.data);
    let newTransformData = [];
    otb.map((item, index) => {
        let stayDate = item.index.date;
        let forecastSegData = (dataService.getSeriesById("OSRContrainedForecast").data) ? dataService.getSeriesById("OSRContrainedForecast").data.data_transformed : [];
        let forecastSegfiltered = forecastSegData.filter((data) => moment(data.stay_date).format("YYYY-MM-DD") === moment(stayDate).format("YYYY-MM-DD"));
        // debugger; 
        if (forecastSegfiltered.length) {
            otb[index] = { index: {} };
            forecastSegfiltered.map((itm, idx) => {
                otb[index]["index"].date = stayDate;
                // Carried per date so downstream can derive Occ%/RevPAR from rooms/revenue over
                // `capacity` (toggle OFF) or `vcapacity` (toggle ON) instead of the feed's
                // pre-computed occ/revpar, which are already vcapacity-based.
                otb[index]["capacity"] = getForecastFeedCapacity([itm]) || item.HotelTotal?.primary?.Capacity;
                otb[index]["vcapacity"] = getForecastFeedVCapacity([itm]) || item.HotelTotal?.primary?.VCapacity || otb[index]["capacity"];
                if (itm.market_code) {
                    let segCode = "Segment_" + itm.market_code;
                    otb[index]["HotelTotal"] = {
                        primary: {
                            "Rooms": itm.predicted_total_cons_rooms,
                            "Occ": itm.predicted_total_cons_occ,
                            "ADR": itm.predicted_total_cons_adr,
                            "RevPAR": itm.predicted_total_cons_revpar,
                            "Revenue": itm.predicted_total_cons_revenue,
                            "SellRate": 0.00,
                        }
                    }
                    otb[index][segCode] = {
                        primary: {
                            "Rooms": itm.predicted_cons_rooms,
                            "Occ": itm.predicted_cons_occ,
                            "ADR": itm.predicted_cons_adr,
                            "RevPAR": itm.predicted_cons_revpar,
                            "Revenue": itm.predicted_cons_revenue,
                            "SellRate": 0.00,
                        }
                    }
                }
            })
        } else {
            // Pre-as-of dates have no forecast rows and fall back to OTB. They still need the same
            // row-level capacity fields the forecast dates get above: the per-date Total row is built
            // from a blank segment block (item['Total'] does not exist), so without these the row has
            // no capacity at all — Occ%/RevPAR ignore the toggle and the VCapIndicator cannot render.
            const pastPrimary = item.HotelTotal && item.HotelTotal.primary;
            otb[index]["capacity"] = pastPrimary && pastPrimary.Capacity;
            otb[index]["vcapacity"] = (pastPrimary && pastPrimary.VCapacity) || (pastPrimary && pastPrimary.Capacity);
            let tmp = { index: item.index, HotelTotal: { primary: item.HotelTotal.primary } };
            for (let k in item) {
                if (k !== "index" && k !== "HotelTotal") {
                    tmp[k] = item[k];
                }
            }
            newTransformData.push(tmp)
        }
    })
    return otb;
}

export function forecastSegmentedData(auth, app_state, params) {
    let { segmentedOn, tile, segments, active_tiles } = params;
    let transformed = [];
    let otbData = [];
    let getPastOtbData = getForecastSegmentedData();
    let segmentTotalAll = {};
    let blankObj = { Rooms: 0, ADR: 0, RevPAR: 0, Revenue: 0, Occ: 0 };
    let blankObjForcast = { predicted_total_cons_rooms: 0, predicted_total_cons_adr: 0, predicted_total_cons_revpar: 0, predicted_total_cons_revenue: 0, predicted_total_cons_occ: 0 };
    let ingonreKeys = ['HotelTotalxx', 'index', 'Segment_TOTAL', 'forecastDate', 'total_forecast_xx'];

    getPastOtbData.map((item, i) => {
        let segmentsKeys = Object.keys(item).sort().reverse();
        // debugger;
        let primaryTotal = {
            predicted_total_cons_rooms: 0,
            predicted_total_cons_occ: 0,
            predicted_total_cons_adr: 0,
            predicted_total_cons_revpar: 0,
            SellRate: 0,
            predicted_total_cons_revenue: 0
        };
        let row = 0;
        let marketSegments = Object.keys(segments.marketSegments);
        marketSegments.push('Total');
        marketSegments.forEach(grouupCode => {
            let key = grouupCode !== 'Total' ? 'Segment_' + grouupCode : grouupCode;
            let totalAll = {};
            let tmp = {};
            // debugger;
            let segment_codes = segments.marketSegments[grouupCode];
            if (!ingonreKeys.includes(key)) {
                // let segmentCode = key.split('_')[1];
                let segmentCode = key;
                let segmentName = grouupCode; //segments.map[segmentCode];
                if (key === "HotelTotal") { segmentName = "Total"; }
                if (!segmentName) {
                    segmentCode = 'Other';
                    segmentName = "Other";
                }

                // segment_codes.forEach((k) => {
                // let key = 'Segment_' + k;

                if (!item[key]) item[key] = {};

                if (!item[key].primary) {

                    item[key].primary = deepCopy(blankObj);
                }
                // Per-date capacity travels with each segment row so getForeCastDataInt_segment can
                // derive Occ%/RevPAR against `capacity` or `vcapacity` per the toggle. There is no
                // per-segment capacity — every segment uses the hotel-wide value, as in the tile view.
                const rowCapacity = getForecastFeedCapacity([item, item[key]['primary']]);
                const rowVCapacity = getForecastFeedVCapacity([item, item[key]['primary']]) || rowCapacity;
                tmp = {
                    stay_date: item.index.date,
                    segment_code: segmentName, //segmentCode,
                    segment: segmentName,//truncate(segmentName, 18),
                    capacity: rowCapacity,
                    vcapacity: rowVCapacity,
                    predicted_total_cons_rooms: item[key]['primary'].Rooms,
                    predicted_total_cons_adr: item[key]['primary'].ADR,
                    predicted_total_cons_revpar: item[key]['primary'].RevPAR,
                    predicted_total_cons_revenue: item[key]['primary'].Revenue,
                    predicted_total_cons_occ: item[key]['primary'].Occ
                }
                otbData.push(tmp);

                /// Segment Wise Total ///
                if (!segmentTotalAll[key]) {
                    segmentTotalAll[key] = deepCopy(blankObjForcast);
                }
                let myKey = key;
                let fieldArr = Object.keys(blankObj);
                if (key !== 'total_forecast') {
                    segmentTotalAll[key]['predicted_total_cons_rooms'] += getCorrectValue(item[key]['primary'].Rooms);
                    segmentTotalAll[key]['predicted_total_cons_revpar'] += getCorrectValue(item[key]['primary'].RevPAR);
                    segmentTotalAll[key]['predicted_total_cons_revenue'] += getCorrectValue(item[key]['primary'].Revenue);
                    segmentTotalAll[key]['predicted_total_cons_occ'] += getCorrectValue(item[key]['primary'].Occ);
                    segmentTotalAll[key]['predicted_total_cons_adr'] += getCorrectValue(parseFloat(item[key]['primary'].Revenue) / parseFloat(item[key]['primary'].Rooms));
                    // Room-nights summed across dates, so the segment's across-dates total row can use
                    // the same capacity basis as its date rows instead of one fixed capacity × days
                    segmentTotalAll[key]['capacity'] = getCorrectValue(segmentTotalAll[key]['capacity']) + getCorrectValue(rowCapacity);
                    segmentTotalAll[key]['vcapacity'] = getCorrectValue(segmentTotalAll[key]['vcapacity']) + getCorrectValue(rowVCapacity);
                }
                // })

            }
        });
    })
    // let resultSet = otbData;//.concat(forecastSegmentTotal(segmentTotalAll, segments, blankObjForcast, auth, app_state));
    let resultSet = otbData.concat(forecastSegmentTotal(segmentTotalAll, segments, blankObjForcast, auth, app_state, active_tiles));
    // debugger;
    return resultSet;
}

// function : To calculate the segment total .
// Modified : 31/Dec/2022

function forecastSegmentTotal(forecastSegmentData, segments, blankObjForcast, auth, app_state, active_tiles = null) {
    let transformed = [];
    let forcastSegmentKeys = Object.keys(forecastSegmentData)
    forcastSegmentKeys.map((key) => {
        let tmp = {};
        if (key !== "total_forecast") {
            let segmentName = getObjectFilter(segments.list, key.split("_")[1], "code");
            if(active_tiles && active_tiles.includes('market')){
                let s = getMarketSegment();
               segmentName =  getObjectFilter(s, key.split("_")[1], "code");
            } 
            if (segmentName.length) {
                tmp = (forecastSegmentData[key]);
                tmp.stay_date = "";
                tmp.segment = segmentName[0].name;
                tmp.segment_code = segmentName[0].code;
                transformed.push(tmp);
            }
        }
    })
    let forecastKeys = Object.keys(blankObjForcast);
    let obj = {}
    transformed.forEach((item) => {
        if (obj[item.segment]) {
            forecastKeys.forEach(element => {
                obj[item.segment][element] = obj[item.segment][element] + item[element];
            });
            // `capacity`/`vcapacity` are hotel-wide room-nights summed over the same date range for
            // every segment code, so carry one across a name merge — adding them would multiply the
            // capacity by the number of merged codes and halve the Occ%.
            if (!getCorrectValue(obj[item.segment]['capacity'])) obj[item.segment]['capacity'] = item['capacity'];
            if (!getCorrectValue(obj[item.segment]['vcapacity'])) obj[item.segment]['vcapacity'] = item['vcapacity'];
        } else {
            obj[item.segment] = item
        }
    })
    let calculatedValue = Object.values(obj);
    // calculation for Occ , ADR and RevPar
    let totalCapacity = getAppData(auth, app_state).property_current_total_capacity;
    let daysCount = daysCountFromRange(app_state);
    let totalCap = totalCapacity * daysCount;
    calculatedValue.map((itm) => {
        const capSum = getCorrectValue(itm['capacity']);
        const effCapSum = capSum > 0 ? capSum : totalCap;
        itm['predicted_total_cons_adr'] = (itm['predicted_total_cons_revenue'] / itm['predicted_total_cons_rooms']);
        itm['predicted_total_cons_occ'] = (itm['predicted_total_cons_rooms'] / effCapSum);
        itm['predicted_total_cons_revpar'] = (itm['predicted_total_cons_revenue'] / effCapSum);
    })
    return calculatedValue;
}



export function getForecastNonSegmentedData() {
    let otb = (dataService.getSeriesById("OSR").data)? deepCopy(dataService.getSeriesById("OSR").data.data) : [];
    let forecastSegData = (dataService.getSeriesById("OSRContrainedForecast").data) ? dataService.getSeriesById("OSRContrainedForecast").data.data : [];
    let newTransformData = [];
    if (!forecastSegData) forecastSegData = [];

    otb.map((item, index) => {
        let itemHotelTotalPrimary = item['HotelTotal']['primary'];

        otb[index] = {
            stay_date: item.index.date,
            predicted_total_cons_rooms: itemHotelTotalPrimary['Rooms'],
            predicted_total_cons_adr: itemHotelTotalPrimary['ADR'],
            predicted_total_cons_revpar: itemHotelTotalPrimary['RevPAR'],
            predicted_total_cons_revenue: itemHotelTotalPrimary['Revenue'],
            predicted_total_cons_occ: itemHotelTotalPrimary['Occ'],
            capacity:itemHotelTotalPrimary['Capacity'],
            vcapacity: itemHotelTotalPrimary['VCapacity'] || itemHotelTotalPrimary['Capacity'],
            index: { date: item.index.date }
        }
        let stayDate = moment(item.index.date).format('YYYY-MM-DD');
        let forecastSegfiltered = forecastSegData.filter((data) => data.stay_date === stayDate);
        if (forecastSegfiltered.length) {
            otb[index] = { index: {} };
            forecastSegfiltered.map((itm, idx) => {
                if (itm.market_code) {
                    otb[index] = {
                        stay_date: stayDate,
                        predicted_total_cons_rooms: itm.predicted_total_cons_rooms,
                        predicted_total_cons_adr: itm.predicted_total_cons_adr,
                        predicted_total_cons_revpar: itm.predicted_total_cons_revpar,
                        predicted_total_cons_revenue: itm.predicted_total_cons_revenue,
                        predicted_total_cons_occ: itm.predicted_total_cons_occ,
                        capacity:itm['capacity'],
                        vcapacity: getForecastFeedVCapacity([itm]) || itm['capacity'],
                        index: { date: stayDate }

                    }
                }
            })
        } else {
            let tmp = { index: item.index, HotelTotal: { primary: item.HotelTotal.primary } };
            for (let k in item) {
                if (k !== "index" && k !== "HotelTotal") {
                    tmp[k] = item[k];
                }
            }
            newTransformData.push(tmp)
        }
    })
    return otb;
}




export function getForecastNonSegmentedDataNew() { /// this is for pricing tile
    let otb = (dataService.getSeriesById("OSR").data) ? deepCopy(dataService.getSeriesById("OSR").data.data) : [];

    let newTransformData = [];
    let forecastSegData = [];
    if (dataService.getSeriesById("OSRContrainedForecast").data
        && dataService.getSeriesById("OSRContrainedForecast").data.data) {
        forecastSegData = dataService.getSeriesById("OSRContrainedForecast").data.data
    }
    otb.map((item, index) => {
        let stayDate = moment(item.index.date).format("YYYY-MM-DD");
        let forecastSegfiltered = forecastSegData.filter((data) => data.stay_date === stayDate);
        if (forecastSegfiltered.length) {
            otb[index] = { index: {} };
            forecastSegfiltered.map((itm, idx) => {
                if (itm.market_code) {
                    otb[index] = {
                        "HotelTotal": {
                            "primary": {
                                stay_date: stayDate,
                                Rooms: itm.predicted_total_cons_rooms,
                                ADR: itm.predicted_total_cons_adr,
                                RevPAR: itm.predicted_total_cons_revpar,
                                Revenue: itm.predicted_total_cons_revenue,
                                Occ: itm.predicted_total_cons_occ,
                                // Consumers (Pricing tile) derive Occ%/RevPAR from rooms/revenue over
                                // Capacity (toggle OFF) or VCapacity (toggle ON) — the feed's own
                                // occ/revpar are already vcapacity-based
                                Capacity: getForecastFeedCapacity([itm]),
                                VCapacity: getForecastFeedVCapacity([itm]) || getForecastFeedCapacity([itm]),

                            }
                        },
                        index: { date: stayDate, }
                    }
                }
            })
        } else {
            let tmp = { index: item.index, HotelTotal: { primary: item.HotelTotal.primary } };
            for (let k in item) {
                if (k !== "index" && k !== "HotelTotal") {
                    tmp[k] = item[k];
                }
            }
            newTransformData.push(tmp)
        }
    })
    return otb;
}


// Function to create data for Forecast for Intellimerge
// Capacity a forecast row's Occ%/RevPAR is measured against: `vcapacity` when the Variable
// Capacity toggle is on, else `capacity`. Rows carry both (see getForecastNonSegmentedData /
// forecastSegmentedData). `effCap` is null when neither is present so callers can fall back.
const getForecastCapacities = (row, useVarCapacity) => {
    if (!row) return { rawCap: null, rawVCap: null, effCap: null };
    const rawCap = getForecastFeedCapacity([row]);
    const rawVCap = getForecastFeedVCapacity([row]);
    return { rawCap, rawVCap, effCap: (useVarCapacity && rawVCap) ? rawVCap : rawCap };
};

// Occ% VCapIndicator (OOO/OOS popover) metadata for a merged-view forecast cell — TableIntelimerge
// reads these off the column's row object, same as the standalone tile.
const stampForecastVcap = (dataObj, { rawCap, rawVCap, effCap }, useVarCapacity) => {
    if (!effCap) return;
    dataObj._vcap = effCap;
    dataObj._vcapLabel = (useVarCapacity && rawVCap) ? 'Variable Capacity' : 'Capacity';
    dataObj._vcapDiffers = !!(rawVCap && rawCap && rawVCap !== rawCap);
};

export const getForeCastDataInt = (mainKey, id, key, index, app_state, forcastFinalData, ui_state) => {
    let dataObj = {};
    // let forcastFinalData = (app_state.workspace_controls.segmented_view) ? [] : getForecastNonSegmentedData();
    let keyValue = key.value;
    let forecastDataIndex = forcastFinalData;
    // Occ%/RevPAR come from rooms/revenue over `capacity` (toggle OFF) or `vcapacity` (toggle ON),
    // matching the standalone Forecast tile. The feed's predicted occ/revpar are already
    // vcapacity-based, so reading them straight through makes the toggle a no-op.
    const useVarCapacity = !!(ui_state && ui_state.showVariableCapacity);
    const capacities = getForecastCapacities(forecastDataIndex, useVarCapacity);
    const effCap = capacities.effCap;

    if (id === "forecast_primary" && mainKey === "primary") {
        if ((keyValue).toLowerCase() == "rooms") {
            dataObj[keyValue] = forecastDataIndex.predicted_total_cons_rooms;
        } else if ((keyValue).toLowerCase() == "occ") {
            dataObj[keyValue] = (effCap)
                ? convertToPercent(forecastDataIndex.predicted_total_cons_rooms / effCap)
                : ((forecastDataIndex.predicted_total_cons_occ) ? convertToPercent(forecastDataIndex.predicted_total_cons_occ) : 0);
            stampForecastVcap(dataObj, capacities, useVarCapacity);
        } else if ((keyValue).toLowerCase() == "adr") {
            dataObj[keyValue] = round(forecastDataIndex.predicted_total_cons_adr);
        } else if ((keyValue).toLowerCase() == "revpar") {
            dataObj[keyValue] = round(effCap
                ? forecastDataIndex.predicted_total_cons_revenue / effCap
                : forecastDataIndex.predicted_total_cons_revpar);
        } else if ((keyValue).toLowerCase() == "revenue") {
            dataObj[keyValue] = round(forecastDataIndex.predicted_total_cons_revenue);
        } else {
            dataObj[keyValue] = round("0.00");
        }
    }

    let userForecastData = [];
    userForecastData = (dataService.getSeriesById("ManualForecast") && dataService.getSeriesById("ManualForecast").data) ? dataService.getSeriesById("ManualForecast").data.data : [];
    // "User Forecast Uploaded" Occ%/RevPAR sit on the same per-date capacity as the System Forecast
    // column beside them (toggle OFF → `capacity`, ON → `vcapacity`). The uploaded feed's own
    // Occ%/RevPAR are fixed-capacity numbers, so passing them straight through leaves this column —
    // and the Difference column derived from it — ignoring the toggle while the forecast column moves.
    // Rooms/ADR/Revenue are user-entered and stay untouched, and no VCapIndicator is stamped here on
    // purpose: this column carries no OOO/OOS popover (unlike forecast_primary above).
    const userForecastOcc = (tf) => (effCap
        ? convertToPercent(getCorrectValue(tf['Rooms']) / effCap)
        : tf['Occ%']);
    const userForecastRevPAR = (tf) => (effCap
        ? getCorrectValue(tf['Revenue']) / effCap
        : tf.RevPAR);
    if (userForecastData && userForecastData.length > 0 && !app_state.workspace_controls.segmented_view) {
        let userForecastIndex = userForecastData[index];
        if (mainKey === "userforecastdata") {
            /// add userForecast Data ///
            if (userForecastData && userForecastData.length > 0 && userForecastIndex) {
                // debugger;
                if ((keyValue).toLowerCase() == "rooms") {
                    dataObj[keyValue] = userForecastIndex['total_forecast']['Rooms'];
                } else if ((keyValue).toLowerCase() == "occ") {
                    dataObj[keyValue] = userForecastOcc(userForecastIndex['total_forecast']);
                } else if ((keyValue).toLowerCase() == "adr") {
                    dataObj[keyValue] = round(userForecastIndex['total_forecast'].ADR);
                } else if ((keyValue).toLowerCase() == "revpar") {
                    dataObj[keyValue] = round(userForecastRevPAR(userForecastIndex['total_forecast']));
                } else if ((keyValue).toLowerCase() == "revenue") {
                    dataObj[keyValue] = round(userForecastIndex['total_forecast'].Revenue);
                }
            }
        }
        if (mainKey === "difference" && userForecastIndex) {
            /// add userForecast Data Difference ///
            // debugger;
            if ((keyValue).toLowerCase() == "rooms") {
                dataObj[keyValue] = forcastFinalData.predicted_total_cons_rooms - userForecastIndex['total_forecast']['Rooms'];
            } else if ((keyValue).toLowerCase() == "occ") {
                // Variance is against the same capacity basis the System Forecast column now displays
                const fcstOcc = effCap
                    ? convertToPercent(forcastFinalData.predicted_total_cons_rooms / effCap)
                    : convertToPercent(forcastFinalData.predicted_total_cons_occ);
                dataObj[keyValue] = fcstOcc - userForecastOcc(userForecastIndex['total_forecast']);
            } else if ((keyValue).toLowerCase() == "adr") {
                dataObj[keyValue] = round(forcastFinalData.predicted_total_cons_adr - userForecastIndex['total_forecast'].ADR);
            } else if ((keyValue).toLowerCase() == "revpar") {
                dataObj[keyValue] = round(effCap
                    ? forcastFinalData.predicted_total_cons_revenue / effCap
                    : forcastFinalData.predicted_total_cons_revpar) - round(userForecastRevPAR(userForecastIndex['total_forecast']));
            } else if ((keyValue).toLowerCase() == "revenue") {
                dataObj[keyValue] = round(forcastFinalData.predicted_total_cons_revenue) - round(userForecastIndex['total_forecast'].Revenue);
            }
        }
    } else {
        if (mainKey === "userforecastdata") {
            /// add userForecast Data ///
            if (userForecastData && userForecastData.length > 0) {
                if ((keyValue).toLowerCase() == "rooms") {
                    dataObj[keyValue] = 0;
                } else if ((keyValue).toLowerCase() == "occ") {
                    dataObj[keyValue] = 0.00;
                } else if ((keyValue).toLowerCase() == "adr") {
                    dataObj[keyValue] = 0.00;
                } else if ((keyValue).toLowerCase() == "revpar") {
                    dataObj[keyValue] = 0.00;
                } else if ((keyValue).toLowerCase() == "revenue") {
                    dataObj[keyValue] = 0.00;
                }
            }
        }
        if (mainKey === "difference") {
            /// add userForecast Data ///
            // if ((keyValue).toLowerCase() == "rooms") {
            //     dataObj[keyValue] = item.predicted_total_cons_rooms;
            // } else if ((keyValue).toLowerCase() == "occ") {
            //     dataObj[keyValue] = convertToPercent(item.predicted_total_cons_occ);
            // } else if ((keyValue).toLowerCase() == "adr") {
            //     dataObj[keyValue] = round(item.predicted_total_cons_adr);
            // } else if ((keyValue).toLowerCase() == "revpar") {
            //     dataObj[keyValue] = round(item.predicted_total_cons_revpar);
            // } else if ((keyValue).toLowerCase() == "revenue") {
            //     dataObj[keyValue] = round(item.predicted_total_cons_revenue);
            // }
        }
    }
    // forecastObj = {...dataObj};
    return dataObj;
}




export const getForeCastDataInt_segment = (mainKey, id, key, index, app_state, forecastData, ui_state) => {
    let dataObj = {};
    let value = key.value;
    // Same rule as the hotel level and the standalone tile: rooms/revenue over `capacity` (toggle
    // OFF) or `vcapacity` (toggle ON). Every segment shares the hotel-wide capacity, so segment
    // rows still sum to the date's Total row.
    const useVarCapacity = !!(ui_state && ui_state.showVariableCapacity);
    const capacities = getForecastCapacities(forecastData, useVarCapacity);
    const effCap = capacities.effCap;
    if (id === "forecast_primary" && mainKey === "primary") {
        if ((value).toLowerCase() == "rooms") {
            dataObj[value] = (forecastData) ? forecastData.predicted_total_cons_rooms : 0;
        } else if ((value).toLowerCase() == "occ") {
            dataObj[value] = (forecastData)
                ? (effCap
                    ? convertToPercent(forecastData.predicted_total_cons_rooms / effCap)
                    : convertToPercent(forecastData.predicted_total_cons_occ))
                : 0;
            stampForecastVcap(dataObj, capacities, useVarCapacity);
        } else if ((value).toLowerCase() == "adr") {
            dataObj[value] = (forecastData) ? round(forecastData.predicted_total_cons_adr) : 0;
        } else if ((value).toLowerCase() == "revpar") {
            dataObj[value] = (forecastData)
                ? round(effCap
                    ? forecastData.predicted_total_cons_revenue / effCap
                    : forecastData.predicted_total_cons_revpar)
                : 0;
        } else if ((value).toLowerCase() == "revenue") {
            dataObj[value] = (forecastData) ? round(forecastData.predicted_total_cons_revenue) : 0;
        } else {
            dataObj[value] = round("0.00");
        }
    }

    let userForecastData = [];
    userForecastData = (dataService.getSeriesById("ManualForecast") && dataService.getSeriesById("ManualForecast").data) ? dataService.getSeriesById("ManualForecast").data.data : [];

    if (userForecastData && userForecastData.length > 0 && !app_state.workspace_controls.segmented_view) {
        let userForecast_totalforecast = userForecastData[index]['total_forecast'];
        if (mainKey === "userforecastdata") {
            /// add userForecast Data ///
            if (userForecastData && userForecastData.length > 0) {
                if ((value).toLowerCase() == "rooms") {
                    dataObj[value] = userForecast_totalforecast['Rooms'];
                } else if ((value).toLowerCase() == "occ") {
                    dataObj[value] = (userForecast_totalforecast['Occ%']);
                } else if ((value).toLowerCase() == "adr") {
                    dataObj[value] = round(userForecast_totalforecast.ADR);
                } else if ((value).toLowerCase() == "revpar") {
                    dataObj[value] = round(userForecast_totalforecast.RevPAR);
                } else if ((value).toLowerCase() == "revenue") {
                    dataObj[value] = round(userForecast_totalforecast.Revenue);
                }
            }
        }
        if (mainKey === "difference") {
            /// add userForecast Data Difference ///
            if ((value).toLowerCase() == "rooms") {
                dataObj[value] = forecastData.predicted_total_cons_rooms - userForecast_totalforecast['Rooms'];
            } else if ((value).toLowerCase() == "occ") {
                dataObj[value] = convertToPercent(forecastData.predicted_total_cons_occ) - (userForecast_totalforecast['Occ%']);
            } else if ((value).toLowerCase() == "adr") {
                dataObj[value] = round(forecastData.predicted_total_cons_adr - userForecast_totalforecast.ADR);
            } else if ((value).toLowerCase() == "revpar") {
                dataObj[value] = round(forecastData.predicted_total_cons_revpar) - round(userForecast_totalforecast.RevPAR);
            } else if ((value).toLowerCase() == "revenue") {
                dataObj[value] = round(forecastData.predicted_total_cons_revenue) - round(userForecast_totalforecast.Revenue);
            }
        }
    } else {
        if (mainKey === "userforecastdata") {
            /// add userForecast Data ///
            if (userForecastData && userForecastData.length > 0) {
                if ((value).toLowerCase() == "rooms") {
                    dataObj[value] = 0;
                } else if ((value).toLowerCase() == "occ") {
                    dataObj[value] = 0.00;
                } else if ((value).toLowerCase() == "adr") {
                    dataObj[value] = 0.00;
                } else if ((value).toLowerCase() == "revpar") {
                    dataObj[value] = 0.00;
                } else if ((value).toLowerCase() == "revenue") {
                    dataObj[value] = 0.00;
                }
            }
        }
        if (mainKey === "difference") {
            /// add userForecast Data ///
            // if ((value).toLowerCase() == "rooms") {
            //     dataObj[value] = item.predicted_total_cons_rooms;
            // } else if ((value).toLowerCase() == "occ") {
            //     dataObj[value] = convertToPercent(item.predicted_total_cons_occ);
            // } else if ((value).toLowerCase() == "adr") {
            //     dataObj[value] = round(item.predicted_total_cons_adr);
            // } else if ((value).toLowerCase() == "revpar") {
            //     dataObj[value] = round(item.predicted_total_cons_revpar);
            // } else if ((value).toLowerCase() == "revenue") {
            //     dataObj[value] = round(item.predicted_total_cons_revenue);
            // }
        }
    }
    // forecastObj = {...dataObj};
    return dataObj;
}


export function forecastMarketSegmentedData(auth, app_state, params) {
    let { segmentedOn, tile, segments, active_tiles } = params;
    let transformed = [];
    let otbData = [];
    let getPastOtbData = getForecastMarketSegmentedData(active_tiles);
    let segmentTotalAll = {};
    let blankObj = { Rooms: 0, ADR: 0, RevPAR: 0, Revenue: 0, Occ: 0 };
    let blankObjForcast = { predicted_total_cons_rooms: 0, predicted_total_cons_adr: 0, predicted_total_cons_revpar: 0, predicted_total_cons_revenue: 0, predicted_total_cons_occ: 0 };
    let ingonreKeys = ['HotelTotalxx', 'index', 'Segment_TOTAL', 'forecastDate', 'total_forecast_xx'];
    let marketSegments = segments.arrUnique;
    marketSegments.push('Total');
    getPastOtbData.map((item, i) => {
        let segmentsKeys = Object.keys(item).sort().reverse();
        let primaryTotal = {
            predicted_total_cons_rooms: 0,
            predicted_total_cons_occ: 0,
            predicted_total_cons_adr: 0,
            predicted_total_cons_revpar: 0,
            SellRate: 0,
            predicted_total_cons_revenue: 0
        };
        let row = 0;
        marketSegments.forEach((grouupCode,idx) => {
            let key = grouupCode !== 'Total' ? 'Segment_' + grouupCode : grouupCode;
            let totalAll = {};
            let tmp = {};
            let segment_codes = segments.marketSegments[grouupCode];
            if (!ingonreKeys.includes(key)) {
                let segmentCode = key;
                let segmentName = grouupCode; //segments.map[segmentCode];
                if (key === "HotelTotal") { segmentName = "Total"; }
                if (!segmentName) {
                    segmentCode = 'Other';
                    segmentName = "Other";
                }
                if (!item[key]) item[key] = {};
                if (!item[key].primary) {
                    item[key].primary = deepCopy(blankObj);
                }
                tmp = {
                    stay_date: item.index.date,
                    segment_code: segmentName, //segmentCode, 
                    segment: segmentName,//truncate(segmentName, 18),
                    predicted_total_cons_rooms: item[key]['primary'].Rooms,
                    predicted_total_cons_adr: item[key]['primary'].ADR,
                    predicted_total_cons_revpar: item[key]['primary'].RevPAR,
                    predicted_total_cons_revenue: item[key]['primary'].Revenue,
                    predicted_total_cons_occ: item[key]['primary'].Occ
                }
                console.log("tmp=> ",tmp);
                otbData.push(tmp);

                /// Segment Wise Total ///
                if (!segmentTotalAll[key]) {
                    segmentTotalAll[key] = deepCopy(blankObjForcast);
                }
                let myKey = key;
                let fieldArr = Object.keys(blankObj);
                if (key !== 'total_forecast') {
                    segmentTotalAll[key]['predicted_total_cons_rooms'] += getCorrectValue(item[key]['primary'].Rooms);
                    segmentTotalAll[key]['predicted_total_cons_revpar'] += getCorrectValue(item[key]['primary'].RevPAR);
                    segmentTotalAll[key]['predicted_total_cons_revenue'] += getCorrectValue(item[key]['primary'].Revenue);
                    segmentTotalAll[key]['predicted_total_cons_occ'] += getCorrectValue(item[key]['primary'].Occ);
                    segmentTotalAll[key]['predicted_total_cons_adr'] += getCorrectValue(parseFloat(item[key]['primary'].Revenue) / parseFloat(item[key]['primary'].Rooms));
                }
                // })

            }
        });
    })
    // let resultSet = otbData;//.concat(forecastSegmentTotal(segmentTotalAll, segments, blankObjForcast, auth, app_state));
    let resultSet = otbData.concat(forecastSegmentTotal(segmentTotalAll, segments, blankObjForcast, auth, app_state, active_tiles));
    return resultSet;
}

export function getForecastMarketSegmentedData(active_tiles) {
    let otb = (active_tiles && active_tiles.includes('market')) ? deepCopy(dataService.getSeriesById("marketOtbSegment").data.data): deepCopy(dataService.getSeriesById("OSRSegment").data.data);
    let newTransformData = [];
    otb.map((item, index) => {
        let stayDate = item.index.date;
        let forecastSegData = [];
        forecastSegData = (dataService.getSeriesById("ForecastMarketSegment").data) ? dataService.getSeriesById("ForecastMarketSegment").data.data : [];
        let forecastSegfiltered = forecastSegData.filter((data) => moment(data.stay_date).format("YYYY-MM-DD") === moment(stayDate).format("YYYY-MM-DD"));
        if (forecastSegfiltered.length) {
            otb[index] = { index: {} };
            forecastSegfiltered.map((i, id) => {
                let seg = "Segment_" + i.market_segment;
                otb[index][seg] = {
                    primary: {
                        "Rooms": 0,
                        "Occ": 0,
                        "ADR": 0,
                        "RevPAR": 0,
                        "Revenue": 0,
                        "SellRate": 0.00,
                    }
                }
            })
            forecastSegfiltered.map((itm, idx) => {
                otb[index]["index"].date = stayDate;
                if (itm.market_segment) {
                    let segCode = "Segment_" + itm.market_segment;
                    otb[index]["HotelTotal"] = {
                        primary: {
                            "Rooms": itm.predicted_total_cons_rooms,
                            "Occ": itm.predicted_total_cons_occ,
                            "ADR": itm.predicted_total_cons_adr,
                            "RevPAR": itm.predicted_total_cons_revpar,
                            "Revenue": itm.predicted_total_cons_revenue,
                            "SellRate": 0.00,
                        }
                    }
                    console.log(stayDate," ",segCode," testing=> ",itm.predicted_cons_occ);
                    otb[index][segCode].primary.Rooms +=  itm.predicted_cons_rooms;
                    otb[index][segCode].primary.Occ +=  itm.predicted_cons_occ;
                    otb[index][segCode].primary.ADR +=  itm.predicted_cons_adr;
                    otb[index][segCode].primary.RevPAR +=  itm.predicted_cons_revpar;
                    otb[index][segCode].primary.Revenue +=  itm.predicted_cons_revenue;
                }
            })
            // forecastSegfiltered.map((i, id) => {
            //     let seg = "Segment_" + i.market_segment;
            //     otb[index][seg].primary.Occ = convertToPercent(otb[index][seg].primary.Occ);
            // })

        } else {
            let tmp = { index: item.index, HotelTotal: { primary: item.HotelTotal.primary } };
            for (let k in item) {
                if (k !== "index" && k !== "HotelTotal") {
                    tmp[k] = item[k];
                }
            }
            newTransformData.push(tmp)
        }
    })
    return otb;
}